<template>
  <div>
    <div class="row">
      <div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 pl-0">
        <div class="d-flex align-items-center">
          <button
            v-if="permission('read', 'financial_account')"
            @click="handleStep('ACCOUNTS')"
            :outlined="step != 'ACCOUNTS'"
            :class="[
              step == 'ACCOUNTS' && 'btn-nav-menu',
              step != 'ACCOUNTS' && 'btn-nav-menu1',
            ]"
          >
            <strong>CONTAS</strong>
          </button>
          <div
            :class="[
              step == 'ACCOUNTS' && 'triangulo-para-direita',
              step != 'ACCOUNTS' && 'triangulo-none',
            ]"
          ></div>
        </div>
        <div class="d-flex align-items-center">
          <button
            v-if="permission('read', 'financial_category')"
            @click="handleStep('CATEGORIES')"
            :outlined="step != 'CATEGORIES'"
            :class="[
              step == 'CATEGORIES' && 'btn-nav-menu',
              step != 'CATEGORIES' && 'btn-nav-menu1',
            ]"
          >
            <strong>CATEGORIAS</strong>
          </button>
          <div
            :class="[
              step == 'CATEGORIES' && 'triangulo-para-direita',
              step != 'CATEGORIES' && 'triangulo-none',
            ]"
          ></div>
        </div>
        <div class="d-flex align-items-center">
          <button
            v-if="permission('read', 'financial_profit_cost_center')"
            @click="handleStep('COST_PROFIT_CENTER')"
            :outlined="step != 'COST_PROFIT_CENTER'"
            :class="[
              step == 'COST_PROFIT_CENTER' && 'btn-nav-menu',
              step != 'COST_PROFIT_CENTER' && 'btn-nav-menu1',
            ]"
          >
            <strong>CENTROS DE CUSTO/LUCRO</strong>
          </button>
          <div
            :class="[
              step == 'COST_PROFIT_CENTER' && 'triangulo-para-direita',
              step != 'COST_PROFIT_CENTER' && 'triangulo-none',
            ]"
          ></div>
        </div>
        <div class="d-flex align-items-center">
          <button
            v-if="permission('read', 'financial_payment_methods')"
            @click="handleStep('PAYMENT_METHODS')"
            :outlined="step != 'PAYMENT_METHODS'"
            :class="[
              step == 'PAYMENT_METHODS' && 'btn-nav-menu',
              step != 'PAYMENT_METHODS' && 'btn-nav-menu1',
            ]"
          >
            <strong>FORMAS DE PAGAMENTO</strong>
          </button>
          <div
            :class="[
              step == 'PAYMENT_METHODS' && 'triangulo-para-direita',
              step != 'PAYMENT_METHODS' && 'triangulo-none',
            ]"
          ></div>
        </div>
        <div class="d-flex align-items-center">
          <button
            v-if="permission('read', 'financial_tags')"
            @click="handleStep('TAGS')"
            :outlined="step != 'TAGS'"
            :class="[
              step == 'TAGS' && 'btn-nav-menu',
              step != 'TAGS' && 'btn-nav-menu1',
            ]"
          >
            <strong>TAGS</strong>
          </button>
          <div
            :class="[
              step == 'TAGS' && 'triangulo-para-direita',
              step != 'TAGS' && 'triangulo-none',
            ]"
          ></div>
        </div>
        <div class="d-flex align-items-center">
          <button
            v-if="permission('read', 'financial_document_types')"
            @click="handleStep('TYPES_OF_DOCUMENTS')"
            :outlined="step != 'TYPES_OF_DOCUMENTS'"
            :class="[
              step == 'TYPES_OF_DOCUMENTS' && 'btn-nav-menu',
              step != 'TYPES_OF_DOCUMENTS' && 'btn-nav-menu1',
            ]"
          >
            <strong>TIPOS DE DOCUMENTOS</strong>
          </button>
          <div
            :class="[
              step == 'TYPES_OF_DOCUMENTS' && 'triangulo-para-direita',
              step != 'TYPES_OF_DOCUMENTS' && 'triangulo-none',
            ]"
          ></div>
        </div>
      </div>
      <div class="col-xl-10 col-lg-10 col-md-9 col-sm-12 col-12 pt-0 pl-0 pr-0">
        <div
          v-if="step == 'ACCOUNTS'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <Accounts />
        </div>
        <div
          v-if="step == 'CATEGORIES'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <Categories />
        </div>
        <div
          v-if="step == 'COST_PROFIT_CENTER'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <CostProfitCenter />
        </div>
        <div
          v-if="step == 'PAYMENT_METHODS'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <PaymentMethods />
        </div>
        <div
          v-if="step == 'TAGS'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <Tags />
        </div>
        <div
          v-if="step == 'TYPES_OF_DOCUMENTS'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <TypesOfDocuments />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Categories from "./Configuration/Categories";

import Accounts from "./Configuration/Accounts";

import CostProfitCenter from "./Configuration/CostProfitCenter";

import PaymentMethods from "./Configuration/PaymentMethods";

import Tags from "./Configuration/Tags";

import TypesOfDocuments from "./Configuration/TypesOfDocuments";

import routes from "../../routes";

import permission from "../../lib/permission";

export default {
  name: "Configuration",
  components: {
    Categories,
    Accounts,
    CostProfitCenter,
    PaymentMethods,
    Tags,
    TypesOfDocuments,
  },
  data() {
    return {
      step: "ACCOUNTS",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,

    handleStep(step) {
      let newMenu = {
        CATEGORIES: "categories",
        ACCOUNTS: "accounts",
        COST_PROFIT_CENTER: "cost-profit-center",
        PAYMENT_METHODS: "payment-methods",
        TAGS: "tags",
        TYPES_OF_DOCUMENTS: "types-of-documents",
      }[step];

      let { nav, menu } = routes.history.current.query;

      if (menu != newMenu) {
        routes.replace({ query: { nav, menu: newMenu } });
      }

      this.step = step;
    },
    retrieve() {
      const { nav, menu } = routes.history.current.query;

      if (menu) {
        let step = {
          categories: "CATEGORIES",
          accounts: "ACCOUNTS",
          "cost-profit-center": "COST_PROFIT_CENTER",
          "payment-methods": "PAYMENT_METHODS",
          tags: "TAGS",
          "types-of-documents": "TYPES_OF_DOCUMENTS",
        }[menu];

        this.step = step;
      } else {
        routes.replace({ query: { nav, menu: "accounts" } });
      }
    },
  },
};
</script>
